// extracted by mini-css-extract-plugin
module.exports = {"section":"_404-module--section--1mnwr","container":"_404-module--container--1bPse","heading":"_404-module--heading--2MnZp","links":"_404-module--links--mc7Zg"};